var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.745647 0.745586C0.989688 0.501545 1.38536 0.501545 1.6294 0.745586L4.00002 3.11621L6.37065 0.745586C6.61469 0.501545 7.01036 0.501545 7.2544 0.745586C7.49844 0.989627 7.49844 1.38529 7.2544 1.62934L4.88377 3.99996L7.2544 6.37059C7.49844 6.61463 7.49844 7.01029 7.2544 7.25433C7.01035 7.49838 6.61469 7.49838 6.37065 7.25433L4.00002 4.88371L1.6294 7.25434C1.38536 7.49838 0.989688 7.49838 0.745647 7.25433C0.501606 7.01029 0.501606 6.61463 0.745647 6.37058L3.11627 3.99996L0.745646 1.62934C0.501606 1.38529 0.501606 0.989627 0.745647 0.745586Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlue);
export default __webpack_public_path__ + "static/media/cross_blue.b5881fd8f64bf21289c8bd29dee8a518.svg";
export { ForwardRef as ReactComponent };